import type { ActionReturn } from "svelte/action";

interface clickOutsideAttributes {
  "on:outsideclick"?: (e: CustomEvent<boolean>) => void;
}

/**
 * This action listens for clicks outside of the element it is attached to.
 * example:
 * <p
 * 	use:clickOutside
 *  on:outsideclick={()=>{console.log('clicked outside'}}
 * >
 */

export function clickOutside(
  node: HTMLElement,
): ActionReturn<undefined, clickOutsideAttributes> {
  window.addEventListener("click", handleClick);

  function handleClick(e: MouseEvent) {
    if (e.target instanceof Element && !node.contains(e.target)) {
      node.dispatchEvent(new CustomEvent("outsideclick"));
    }
  }

  return {
    destroy() {
      window.removeEventListener("click", handleClick);
    },
  };
}
